import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const PartnerUnreadContext = createContext({ unread: 0, clearUnread: () => {}, decrementUnread: () => {} });

export const PartnerUnreadProvider = ({ children }) => {
  const { admin, isPartner } = useAuth();
  const [unread, setUnread] = useState(admin?.unreadCount || 0);

  // Poll every 30s
  useEffect(() => {
    if (!isPartner) return;
    const fetch = () => axios.get('/api/requests/my-unread').then(r => setUnread(r.data.count)).catch(() => {});
    fetch();
    const iv = setInterval(fetch, 30000);
    return () => clearInterval(iv);
  }, [isPartner]);

  const clearUnread = useCallback(() => {
    setUnread(0);
    axios.post('/api/requests/read').catch(() => {});
  }, []);

  // Decrement by a specific amount (when one thread is read)
  const decrementUnread = useCallback((amount = 1) => {
    setUnread(prev => Math.max(0, prev - amount));
  }, []);

  return (
    <PartnerUnreadContext.Provider value={{ unread, setUnread, clearUnread, decrementUnread }}>
      {children}
    </PartnerUnreadContext.Provider>
  );
};

export const usePartnerUnread = () => useContext(PartnerUnreadContext);
